document.addEventListener('DOMContentLoaded', function () {
    const variantButtons = document.querySelectorAll('.variant-button');
    
    variantButtons.forEach(button => {
      button.addEventListener('click', function () {
        const variantId = this.getAttribute('data-variant-id');
        addToCart(variantId);
      });
    });
  
    function addToCart(variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        // Update the mini cart
        //updateMiniCart();
        
        /*
        * open cart Drawer Update
        */
        onCartDrawerUpdate()
        setTimeout(() => {
            // open
            open()
        }, 200)

      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
    }
  
    function updateMiniCart() {
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const miniCart = document.querySelector('.mini-cart');
        if (miniCart) {
          miniCart.classList.add('open'); // Open the mini cart
          // Update the mini cart content here if necessary
        }
  
        // Alternatively, trigger an event that your theme's mini cart listens for
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  
        
        
      })
      .catch(error => {
        console.error('Error updating mini cart:', error);
      });
    }
  });
  
  
  
  
  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Obtener todos los inputs de radio para las tallas
    const radioInputs = document.querySelectorAll('.m-product-option--node input[type="radio"]');
  
    // Deseleccionar cualquier input que esté seleccionado por defecto
    radioInputs.forEach(input => {
      input.checked = false;
    });
  
    // Mapa de nombres largos a nombres cortos
    const sizeMapping = {
      "X Small": "XS",
      "Small": "S",
      "Medium": "M",
      "Large": "L",
      "X Large": "XL",
      "XX Large": "XXL",
      "XXX Large": "XXXL"
    };
  
    // Función para actualizar la clase "Seleccionado" en la lista de variantes
    function updateSelectedClass() {
      // Primero, remover la clase "Seleccionado" de todos los items
      const variantItems = document.querySelectorAll('#variant-stock-list li');
      variantItems.forEach(item => {
        item.classList.remove('Seleccionado');
      });
  
      // Verificar cuál input está seleccionado
      radioInputs.forEach(input => {
        if (input.checked) {
          // Obtener el valor del input (la talla)
          const selectedSize = input.value.trim();
  
          // Buscar el item correspondiente en la lista de variantes
          variantItems.forEach(item => {
            if (item.getAttribute('data-variant-title') === selectedSize) {
              // Agregar la clase "Seleccionado" al item correspondiente
              item.classList.add('Seleccionado');
            }
          });
        }
      });
  
      // Actualizar la clase del ul según el stock
      updateStockStatusClass();
    }
  
    // Función para cambiar los nombres de las variantes
    function updateVariantNames() {
      const labels = document.querySelectorAll('.m-product-option--node__label');
      labels.forEach(label => {
        const originalName = label.textContent.trim();
        if (sizeMapping[originalName]) {
          label.textContent = sizeMapping[originalName];
        }
      });
    }
  
    // Función para actualizar la clase del ul según el stock
    function updateStockStatusClass() {
      const ulElement = document.getElementById('variant-stock-list');
      const selectedVariantItem = document.querySelector('#variant-stock-list li.Seleccionado');
  
      if (selectedVariantItem) {
        if (selectedVariantItem.classList.contains('in-stock')) {
          ulElement.className = 'stock-status in-stock';
        } else if (selectedVariantItem.classList.contains('low-stock')) {
          ulElement.className = 'stock-status low-stock';
        } else if (selectedVariantItem.classList.contains('no-stock')) {
          ulElement.className = 'stock-status no-stock';
        }
      } else {
        if(ulElement) {
            ulElement.className = 'stock-status no-stock';
        }
      }
    }
  
    // Agregar evento de cambio a cada input de radio
    radioInputs.forEach(input => {
      input.addEventListener('change', () => {
        updateSelectedClass();
      });
    });
  
    // Llamar a las funciones al cargar la página para establecer el estado inicial
    updateSelectedClass();
    updateVariantNames();
  });
  
  
  
  
  
  
  
  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Obtener el div que contiene la información del stock
    const stockDataTotalDiv = document.querySelector('.product-stock-data-total');
  
    // Obtener todos los inputs de radio para las tallas
    const radioInputs = document.querySelectorAll('.m-product-option--node input[type="radio"]');
  
    // Función para verificar si alguna variante está seleccionada
    function checkVariantSelection() {
      let variantSelected = false;
  
      radioInputs.forEach(input => {
        if (input.checked) {
          variantSelected = true;
        }
      });
  
      // Si ninguna variante está seleccionada, agregar la clase "active"
      if (!variantSelected) {
        if(stockDataTotalDiv) {
            stockDataTotalDiv.classList.add('active');
        }
      } else {
        if(stockDataTotalDiv) {
            stockDataTotalDiv.classList.remove('active');
        }
      }
    }
  
    // Verificar la selección al cargar la página
    checkVariantSelection();
  
    // Agregar evento de cambio a cada input de radio
    radioInputs.forEach(input => {
      input.addEventListener('change', checkVariantSelection);
    });
  });
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Obtener el contenedor del tooltip
    const tooltipContainer = document.getElementById('tooltip-container');
    if (tooltipContainer) {
      const tooltipContent = tooltipContainer.innerHTML;
  
      // Crear un nuevo elemento para el tooltip
      const tooltipElement = document.createElement('div');
      tooltipElement.innerHTML = tooltipContent;
  
      // Obtener el div con la clase m-product-form--wrapper
      const productFormWrapper = document.querySelector('.m-product-form--wrapper');
  
      // Insertar el tooltip dentro del div m-product-form--wrapper
      if (productFormWrapper) {
        productFormWrapper.appendChild(tooltipElement);
      }
  
      // Remover el contenedor original del tooltip
      tooltipContainer.remove();
    }
  });
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
//   <!-- JavaScript para manejar el popup sizeguide -->
  document.addEventListener('DOMContentLoaded', function() {
    // Obtener el contenedor del tooltip
    const tooltipContainer = document.getElementById('tooltip-container');
    if (tooltipContainer) {
      const tooltipContent = tooltipContainer.innerHTML;
  
      // Crear un nuevo elemento para el tooltip
      const tooltipElement = document.createElement('div');
      tooltipElement.innerHTML = tooltipContent;
  
      // Obtener el div con la clase m-product-form--wrapper
      const productFormWrapper = document.querySelector('.m-product-form--wrapper');
  
      // Insertar el tooltip dentro del div m-product-form--wrapper
      if (productFormWrapper) {
        productFormWrapper.appendChild(tooltipElement);
      }
  
      // Remover el contenedor original del tooltip
      tooltipContainer.remove();
    }
  
    // Obtener el div del popup y moverlo al nivel del body
    const sizeGuidePopup = document.getElementById('size-guide-popup');
    if (sizeGuidePopup) {
      document.body.appendChild(sizeGuidePopup);
    }
  
    // Mover el enlace del size guide dentro del div .m-product-option
    const sizeGuideLink = document.getElementById('size-guide-link');
    const productOptionDiv = document.querySelector('.m-product-option');
  
    if (sizeGuideLink && productOptionDiv) {
      productOptionDiv.appendChild(sizeGuideLink);
    }
  
    var sizeGuideClose = document.querySelector('.size-guide-popup-close');
    
    if(sizeGuideLink) {
        sizeGuideLink.addEventListener('click', function(event) {
          event.preventDefault();
          sizeGuidePopup.style.display = 'block';
        });
    }
    
    if(sizeGuideClose) {
        sizeGuideClose.addEventListener('click', function() {
          sizeGuidePopup.style.display = 'none';
        });
    }
  
    window.addEventListener('click', function(event) {
      if (event.target == sizeGuidePopup) {
        sizeGuidePopup.style.display = 'none';
      }
    });
  });
  
  
  
  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', () => {
    // Selecciona todos los elementos con la clase 'm-cart-item__title'
    const titles = document.querySelectorAll('.m-cart-item__title');
    
    titles.forEach(title => {
      // Extrae el texto del título
      const text = title.textContent.trim();
      
      // Separa el texto por el último '|'
      const lastPipeIndex = text.lastIndexOf('|');
      if (lastPipeIndex !== -1) {
        const mainText = text.substring(0, lastPipeIndex).trim();
        const secondaryText = text.substring(lastPipeIndex + 1).trim();
        
        // Crea los nuevos elementos
        const newDiv = document.createElement('div');
        const mainTextP = document.createElement('p');
        const secondaryTextP = document.createElement('p');
        
        // Asigna las clases y los textos a los nuevos elementos
        mainTextP.className = 'new-cart-item-color';
        secondaryTextP.className = 'new-cart-item-title';
        mainTextP.textContent = secondaryText;
        secondaryTextP.textContent = mainText;
        
        // Añade los nuevos elementos al div
        newDiv.appendChild(mainTextP);
        newDiv.appendChild(secondaryTextP);
        
        // Reemplaza el enlace original con el nuevo div
        title.parentNode.replaceChild(newDiv, title);
      }
    });
  });
  
  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', () => {
    function moveQuantityColumn() {
      if (window.innerWidth < 768) {
        // Selecciona todos los elementos con la clase 'm-cart__column--price'
        const priceColumns = document.querySelectorAll('.m-cart__column--price');
  
        priceColumns.forEach(priceColumn => {
          // Selecciona el elemento con la clase 'm-cart__column--quantity'
          const quantityColumn = priceColumn.parentNode.querySelector('.m-cart__column--quantity');
  
          if (quantityColumn && !priceColumn.contains(quantityColumn)) {
            // Mueve el div .m-cart__column--quantity dentro de .m-cart__column--price
            priceColumn.appendChild(quantityColumn);
          }
        });
      } else {
        // Revertir el movimiento si la pantalla es mayor o igual a 768px
        const quantityColumns = document.querySelectorAll('.m-cart__column--quantity');
        
        quantityColumns.forEach(quantityColumn => {
          const originalParent = quantityColumn.closest('.m-cart__item'); // Asegúrate de tener un selector para el contenedor original
          if (originalParent && !originalParent.contains(quantityColumn)) {
            // Mueve el div .m-cart__column--quantity de vuelta a su posición original
            originalParent.insertBefore(quantityColumn, originalParent.querySelector('.m-cart__column--price'));
          }
        });
      }
    }
  
    // Ejecutar al cargar la página
    moveQuantityColumn();
  
    // Agregar un event listener para verificar el cambio de tamaño de la ventana
    window.addEventListener('resize', moveQuantityColumn);
  });
  
  
  
  
  
  
  /*
  * Cart Open Drawer
  */
  
  function getCart() { return fetchJSON(window.Shopify.routes.root + "cart.json") }
  
  function onCartDrawerUpdate(e = !0) {
  
      fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
          .then((e => e.text()))
          .then((t => {
              getSectionsToRender().forEach((r => {
                  if ("cart-items" === r.block) {
                      (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = getSectionInnerHTML(t, r.selector)
                  } else if (e) {
                      (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = getSectionInnerHTML(t, r.selector)
                  }
  
              }))
  
              
  
          })).catch((e => {
              console.log("error", e)
          })),
          getCart().then((e => {
                document.querySelector("#MinimogCartDrawer").classList.toggle("m-cart--empty", 0 === e.item_count),
                updateCartCount(e.item_count)
  
                // open cart drawer
                console.log("open drawer")
                open()
  
          }))
  }
  
  function getSectionInnerHTML(e, t = ".shopify-section") {
      return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
  }
  
  function getSectionsToRender() {
      return [
          { id: "cart-drawer", selector: "[data-minimog-cart-items]", block: "cart-items" },
          { id: "cart-drawer", selector: "[data-minimog-cart-discounts]", block: "cart-footer" },
          { id: "cart-drawer", selector: "[data-cart-subtotal]", block: "cart-footer" },
          { id: "cart-drawer", selector: "[data-minimog-gift-wrapping]", block: "cart-footer" }
      ]
  }
  
  function updateCartCount(e) { 
      document.querySelectorAll(".m-cart-count-bubble").forEach((t => { e > 0 ? (t.textContent = e, t.classList.remove("m:hidden")) : t.classList.add("m:hidden") })) 
  } 
  
  
  function open(e) { 
      e && document.querySelector("#MinimogCartDrawer").setActiveElement(e), 
      document.querySelector("#MinimogCartDrawer").classList.add("m-cart-drawer--active"), 
      requestAnimationFrame((() => { 
          document.querySelector("#MinimogCartDrawer").style.setProperty("--m-bg-opacity", "0.5"), 
          document.querySelector("#MinimogCartDrawer").cartDrawerInner.style.setProperty("--translate-x", "0") 
      })), window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer), 
  
      document.documentElement.classList.add("prevent-scroll")
  }
  
  
  
  // button events
  // let buttonsEventsClothes = document.querySelectorAll(".m-product-card__variant-buttons")
  
  // buttonsEventsClothes.forEach(elementButton => {
  //     elementButton.addEventListener("click", (elementClicked) => {
  //         console.log("boton clicked", elementClicked)
  
  // onCartDrawerUpdate()
  
  // setTimeout(() => {
  //     console.log("open drawer")
  //     // open
  //     open()
  // }, 500)
  
          
  //     })
  
  // })
  
  
  
  
  
  
  
  
  
  
  
  
  
  











// Diccionario de colores
const colorMap = {
  'Black': '#1C1C1C',
  'Chalk White': '#EBE4DA',
  'Dark Olive': '#6C6B62',
  'Earth Brown': '#564E4D',
  'Midnight Blue': '#2C2B3D',
  'Concrete Gray': '#D7CEC5',
  'Coral Pink': '#D59999',
  'Marina Blue': '#9AAEC1',
  'Sea Lilac': '#C7BAC4',
  'Surf Green': '#A2B1A8',
  'Ash Gray': '#99949A',
  'White': '#FFFFFF',
  'Platinum Gray': '#DBDAD4',
  'Rust Orange': '#B9523C',
  'Steel Blue': '#6088A4',
  'Smoke Blue': '#809CA7',
  'Brick Red': '#B5332F',
  'Forest Green': '#447144',
  'Cinder Brown': '#968778',
  'Pacific Blue': '#243F6C',
  'Onyx White': '#F1F0E1',
  'Pale Pink': '#D7BCBB',
  'Sand': '#D8CBB7',
  'Shadow Gray': '#AAA59E',
  'Cordovan Red': '#623845',
  'Spicy Mustard': '#E1AC5C',
  'Leather Brown': '#B7603B',
  'Dark Chocolate': '#41372D',
  'Heather Gray': '#3A3836',
  'Wine Red':'#6E1A25',
  'Jet Black':'#1B1B1B',
  'Pine Green':'#2C5743',
  'Ivory':'#E7E0CE',
  'Indigo Blue':'#2F385F',
  'Walnut Brown':'#6D5B45',
  'Desert Khaki':'#A48E65',
};























// Función para reemplazar el valor del color
function replaceColorLabels() {
  const labels = document.querySelectorAll('label');

  labels.forEach(label => {
    const input = label.querySelector('input[type="checkbox"]');
    const span = label.querySelector('.m-facet--color-label');
    
    if (input && span) {
      const colorValue = input.value.trim();
      
      // Si el valor del color está en el diccionario, reemplazarlo
      if (colorMap[colorValue]) {
        const newColor = colorMap[colorValue];
        span.style.backgroundColor = newColor;
      }
    }
  });
}

// Función para añadir clases basadas en los títulos de los widgets
function updateFilterWidgetClasses() {
  var filterWidgets = document.querySelectorAll('.m-filter--widget.m-accordion--item.open');
  
  filterWidgets.forEach(function(widget) {
    // Encontrar el título del widget
    var titleElement = widget.querySelector('.m-filter--widget-title span');
    if (titleElement) {
      var titleText = titleElement.textContent.trim().replace(/\s+/g, '-'); // Obtener el texto del span y reemplazar espacios con guiones
      
      // Añadir el texto del span como una nueva clase al elemento del widget
      widget.classList.add(titleText);
    }
  });
}

// Función para añadir la clase "checked" a los labels de inputs marcados
function addCheckedClassToLabels() {
  const labels = document.querySelectorAll('label.m-facet--checkbox');
  
  labels.forEach(label => {
    const input = label.querySelector('input[type="checkbox"]');
    
    if (input && input.checked) {
      label.classList.add('checked');
    } else {
      label.classList.remove('checked');
    }
  });
}

// Función para ejecutar todos los scripts
function executeScripts() {
  replaceColorLabels();
  updateFilterWidgetClasses();
  addCheckedClassToLabels();
}

// Ejecutar la función al cargar la página
document.addEventListener('DOMContentLoaded', executeScripts);

// Crear un MutationObserver para observar cambios en el DOM
const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      executeScripts();
    }
  }
});

// Configurar el observer para observar cambios en el cuerpo del documento
observer.observe(document.body, { childList: true, subtree: true });




























document.addEventListener('DOMContentLoaded', function () {
    const radioInputs = document.querySelectorAll('.m-product-option--node input[type="radio"]');
    const addToCartButton = document.querySelector('button[name="add"]');
    const productFormWrapper = document.querySelector('.m-product-form--wrapper');

    // Deseleccionar cualquier input que esté seleccionado por defecto
    radioInputs.forEach(input => {
        input.checked = false;
    });

    // Crear el contenedor del mensaje de error
    const errorMessage = document.createElement('div');
    errorMessage.id = 'error-message';
    errorMessage.style.display = 'none';
    errorMessage.textContent = 'Por favor, selecciona una talla';

    // Insertar el mensaje de error justo debajo del div con clase 'm-product-form--wrapper'
    productFormWrapper.parentNode.insertBefore(errorMessage, productFormWrapper.nextSibling);

    // Añadir evento de click al botón de añadir al carrito
    addToCartButton.addEventListener('click', function (event) {
        const selectedSize = Array.from(radioInputs).some(input => input.checked);
        if (!selectedSize) {
            event.preventDefault();
            errorMessage.style.display = 'block';
        } else {
            errorMessage.style.display = 'none';
        }
    });

    // Ocultar mensaje de error cuando se selecciona una talla
    radioInputs.forEach(input => {
        input.addEventListener('change', () => {
            errorMessage.style.display = 'none';
        });
    });
});


























// Función para obtener el valor del filtro de la URL
function obtenerFiltroDeURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get('talla'); // Ajusta 'talla' al nombre real del parámetro de tu filtro en la URL
}

// Función para ocultar productos sin stock según el filtro aplicado
function ocultarProductosSinStock() {
    const filtro = obtenerFiltroDeURL();
    if (!filtro) return; // Si no hay filtro aplicado, salir de la función

    // Obtener todos los elementos con la clase 'm-product-item'
    const productos = document.querySelectorAll('.m-product-item');

    productos.forEach(producto => {
        // Obtener todas las clases del producto
        const clases = producto.classList;
        
        // Verificar si alguna clase coincide con el patrón 'no-stock-[talla]'
        clases.forEach(clase => {
            if (clase.startsWith('no-stock-')) {
                const talla = clase.replace('no-stock-', '');
                
                // Comparar la talla con el filtro aplicado
                if (talla === filtro) {
                    // Aplicar display: none al producto si coincide con el filtro
                    producto.style.display = 'none';
                } else {
                    // Mostrar el producto si no coincide con el filtro
                    producto.style.display = '';
                }
            }
        });
    });
}

// Función para monitorear cambios en la URL
function monitorearCambiosEnURL() {
    let ultimaURL = window.location.href;
    
    new MutationObserver(() => {
        const urlActual = window.location.href;
        if (urlActual !== ultimaURL) {
            ultimaURL = urlActual;
            ocultarProductosSinStock(); // Aplicar filtro cuando la URL cambia
        }
    }).observe(document, { subtree: true, childList: true });
}

// Iniciar la monitorización de cambios en la URL
document.addEventListener('DOMContentLoaded', function() {
    monitorearCambiosEnURL();
    ocultarProductosSinStock(); // Aplicar filtro al cargar la página
});






























document.addEventListener('DOMContentLoaded', function() {
  // Función para comprobar y ocultar los elementos m-product-item
  function checkAndHideProducts() {
    const activeFacetItems = document.querySelectorAll('.m-active-facets--item');
    const productItems = document.querySelectorAll('.m-product-item');

    let activeFacetClasses = [];

    activeFacetItems.forEach(facetItem => {
      facetItem.classList.forEach(cls => {
        if (cls !== 'm-active-facets--item') {
          activeFacetClasses.push(cls);
        }
      });
    });

    productItems.forEach(productItem => {
      activeFacetClasses.forEach(activeClass => {
        if ([...productItem.classList].some(cls => cls.includes(activeClass))) {
          productItem.style.display = 'none';
        }
      });
    });
  }

  // Llamar a la función inicialmente para ocultar los productos ya cargados
  checkAndHideProducts();

  // Crear un MutationObserver para observar cambios en el DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        checkAndHideProducts();
      }
    });
  });

  // Configurar el observer para observar cambios en todo el body
  observer.observe(document.body, {
    childList: true, // Observar adiciones y eliminaciones de hijos
    attributes: true, // Observar cambios de atributos
    subtree: true // Observar todo el subárbol
  });
});